import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteContactLogModal = ({ isOpen, onClose, onConfirm, log }) => {
  if (!log) return null;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete Contact Log"
      bodyMessage={`Are you sure you want to delete this log?\n\n"${log.reason}"`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
    />
  );
};

export default DeleteContactLogModal;